/** Canonical pages and compatibility mapping for former ?tab= links. */
export const billingSettingsPages = {
  overview: {
    path: '/practice/billing-settings',
    label: 'Claim setup',
    subtitle: 'Set up your practice to submit claims electronically to insurance companies.',
  },
  identities: {
    path: '/practice/billing-settings/identities',
    label: 'Billing identities',
    subtitle: 'Manage the NPI and Tax ID combinations your practice uses for billing.',
  },
  facilities: {
    path: '/practice/billing-settings/facilities',
    label: 'Service facilities',
    subtitle: 'Manage the locations where your practice provides care.',
  },
  enrollments: {
    path: '/practice/billing-settings/enrollments',
    label: 'Payer enrollments',
    subtitle: 'Enroll your practice with payers for electronic claims and remittances.',
  },
  'fee-schedule': {
    path: '/practice/billing-settings/fee-schedule',
    label: 'Fee schedule',
    subtitle: 'Set the fees your practice charges for services.',
  },
  compensation: {
    path: '/practice/billing-settings/compensation',
    label: 'Commission rates',
    subtitle: 'Manage how compensation is calculated for your practice members.',
  },
  'data-migration': {
    path: '/practice/billing-settings/data-migration',
    label: 'Import & export',
    subtitle: 'Import billing records and export data from your practice.',
  },
  // JotBill and scheduling link directly to Stripe setup. This is not the patient billing worklist.
  'patient-payments': {
    path: '/practice/billing-settings/payment-connection',
    label: 'Payment connection',
    subtitle: 'Connect your payment account to collect payments.',
  },
} as const;

export type BillingSettingsSection = keyof typeof billingSettingsPages;

export function isBillingSettingsSection(value: string | null): value is BillingSettingsSection {
  return value !== null && Object.hasOwn(billingSettingsPages, value);
}
